import { objectSpread2 as _objectSpread2 } from "../_virtual/_rollupPluginBabelHelpers.js";
import { isEmpty } from 'lodash';
var MAX_SCALE = 5;

var getDistance = function getDistance(t1, t2) {
  return Math.hypot(t1.pageX - t2.pageX, t1.pageY - t2.pageY);
};

var handlePinchZoomTouchStart = function handlePinchZoomTouchStart(e, pdfDocumentStore, viewer) {
  if (e.touches.length < 2) return; // The wrapper should be the scrollable element that contains the PDF document (viewer).

  var wrapper = document.getElementById('pdf-wrapper');
  if (!wrapper.contains(e.target)) return; // Find the center of the two touch points.

  var t1 = e.touches[0];
  var t2 = e.touches[1];
  var pageX = (t1.pageX + t2.pageX) / 2;
  var pageY = (t1.pageY + t2.pageY) / 2; // Find the x, y coordinates of the PDF document (viewer) where the user has touched.

  var docX = pageX - viewer.offsetLeft + wrapper.scrollLeft;
  var docY = pageY - viewer.offsetTop + wrapper.scrollTop;
  var touch = {
    viewer: viewer,
    wrapper: wrapper,
    pageX: pageX,
    pageY: pageY,
    docX: docX,
    docY: docY,
    startingPinchDistance: getDistance(t1, t2),
    previousPinchScale: 0,
    pinchScale: 1
  };
  pdfDocumentStore.setPinchZoomTouch(touch);
};

var handlePinchZoomTouchMove = function handlePinchZoomTouchMove(e, pdfDocumentStore) {
  var touch = _objectSpread2({}, pdfDocumentStore.pinchZoomTouch);

  if (isEmpty(touch) || e.touches.length < 2) return; // Prevent native page zooming

  e.preventDefault(); // Calculate how much to scale based on how much the user dragged their fingers

  var currentPinchDistance = getDistance(e.touches[0], e.touches[1]);
  touch.pinchScale = currentPinchDistance / touch.startingPinchDistance;
  if (touch.pinchScale * pdfDocumentStore.scale > MAX_SCALE) return; // Use CSS transform properties so the user sees the zooming happening

  touch.viewer.style.transformOrigin = "".concat(touch.docX, "px ").concat(touch.docY, "px");
  touch.viewer.style.transform = "scale(".concat(touch.pinchScale, ")");
  pdfDocumentStore.setPinchZoomTouch(touch);
};

var handlePinchZoomTouchEnd = function handlePinchZoomTouchEnd(e, pdfDocumentStore) {
  var touch = _objectSpread2({}, pdfDocumentStore.pinchZoomTouch);

  if (isEmpty(touch) || touch.pinchScale * pdfDocumentStore.scale > MAX_SCALE || // Sometimes 'touchend' will be called twice with the same value of touch.pinchScale depending
  // on how fast both fingers leave the screen, so we want to ignore the duplicate call
  touch.previousPinchScale === touch.pinchScale) {
    return undefined;
  }

  pdfDocumentStore.setPinchZoomTouch(_objectSpread2(_objectSpread2({}, touch), {}, {
    previousPinchScale: touch.pinchScale
  })); // Adjust the scroll position to account for zooming in/out

  var viewer = touch.viewer,
      wrapper = touch.wrapper;
  var newDocX = touch.docX * touch.pinchScale;
  var newDocY = touch.docY * touch.pinchScale;
  var newScrollLeft = newDocX - touch.pageX + viewer.offsetLeft;
  var newScrollTop = newDocY - touch.pageY + viewer.offsetTop;
  var newScale = pdfDocumentStore.scale * touch.pinchScale;
  pdfDocumentStore.setScale(newScale);
  wrapper.scrollLeft = newScrollLeft;
  wrapper.scrollTop = newScrollTop; // Clean up

  viewer.style.transform = 'none';
  viewer.style.transformOrigin = 'unset';
  pdfDocumentStore.setPinchZoomTouch(undefined); // Return the touch object just for testing purposes so we can make sure that
  // the correct modifications were made to the wrapper/viewer elements.

  return touch;
};

export { handlePinchZoomTouchEnd, handlePinchZoomTouchMove, handlePinchZoomTouchStart };